import './App.css';
import { Route, Routes, BrowserRouter as Router, useLocation } from 'react-router-dom';

import AOS from 'aos';
import 'aos/dist/aos.css';

import { useEffect } from 'react';

import Navbar from './NavBar/navbar';
import Footer from './NavBar/Footer';
import Home from './Pages/Home';
import AboutMe from './Pages/AboutMe/AboutMe';
import AdministrativeResponsibilities from './Pages/AboutMe/AdministrativeResponsibilities';
import Book from './Pages/Research/Book';
import CreativeHome from './Pages/CreativeHome';
import TalksAndEvents from './Pages/Home/TalksAndEvents';
import CreateEvent from './Pages/CreateEvent';
import Login from './Admin/Login';
import AdminDashboard from './Admin/AdminDashboard';
import ProtectedRoute from './Admin/ProtectedRoute';
import AwardsMotionPage from './Awards/AwardsMotionPage';
import Biosketch from './Pages/AboutMe/Biosketch';
import IndustryExperience from './Pages/AboutMe/IndustryExperience';
import GrantsResearchProjects from './Pages/ConsultingPorjectsMDPs/GrantsResearchProjects';
import MDPs from './Pages/ConsultingPorjectsMDPs/MDPs';
import DoctoralSection from './Pages/DoctoralSection';
import CaseStudies from './Pages/Research/CaseStudies';
import Conferences from './Pages/Research/Conferences';
import DoctoralScholars from './Pages/Research/DoctoralScholars';
import Patents from './Pages/Research/Patents';
import JournalPublications from './Pages/Research/JournalPublications';
import CoursesTaught from './Pages/Teaching/CoursesTaught';
import Workshops from './Pages/Workshops';
import Contact from './Pages/Contact';
import AskMe from './Pages/AskMe';

function AppContent() {
  const location = useLocation();

  // Checks if the active page is an admin route
  const isAdminPage = location.pathname.toLowerCase().startsWith('/admin');

  // Checks if the active page is the Awards & Honours section
  const isAwardsPage = location.pathname.toLowerCase() === '/awardsandhonours';

  return (
    <>
      {/* Navbar renders on all pages EXCEPT admin pages */}
      {!isAdminPage && <Navbar />}
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/AboutMe" element={<AboutMe />} />
        <Route path="/AboutMe/AdministrativeResponsibilities" element={<AdministrativeResponsibilities />} />
        <Route path="/AboutMe/IndustryExperience" element={<IndustryExperience />} />
        <Route path="/Research/Books" element={<Book />} />
        <Route path="/AboutMe/BioSketch" element={<Biosketch />} />
        <Route path="/TalksAndEvents" element={<TalksAndEvents />} />
        <Route path="/AwardsAndHonours" element={<AwardsMotionPage />} />
        <Route path="/Consulting-Projects-MDPs/Grants–ResearchProjects-Consulting" element={<GrantsResearchProjects />} />
        <Route path="/Consulting-Projects-MDPs/MDPs" element={<MDPs />} />
        <Route path="/DoctoralSection" element={<DoctoralSection />} />
        <Route path="/Research/CaseStudies" element={<CaseStudies />} />
        <Route path="/Research/Conferences" element={<Conferences />} />
        <Route path="/Research/DoctoralScholars" element={<DoctoralScholars />} />
        <Route path="/Research/Patents" element={<Patents />} />
        <Route path="/Research/JournalPublications-BookChapters" element={<JournalPublications />} />
        <Route path="/Teaching/CoursesTaught" element={<CoursesTaught />} />
        <Route path="/Workshops" element={<Workshops />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/AskMe" element={<AskMe />} />

        {/* Admin */}
        <Route path="/admin/CreateEvent" element={<CreateEvent />} />
        <Route path="/admin/login" element={<Login />} />
        <Route 
          path="/admin/events" 
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* Default */}
        <Route path="*" element={<Home />} />
      </Routes>

      {/* Footer renders on all pages except /AwardsAndHonours and admin pages */}
      {!isAwardsPage && !isAdminPage && <Footer />}
    </>
  );
}

function AOSRouteHandler() {
  const location = useLocation();

  useEffect(() => {
    // Re-calculates positions and animates elements on the new page
    AOS.refresh();
  }, [location.pathname]);

  return null;
}

function App() {
  useEffect(() => {
    // Initialize AOS once when the app mounts
    AOS.init({
      duration: 800,
      once: false, // Ensures animations run smoothly
      easing: 'ease-in-out',
    });
  }, []);

  return (
    <div className="bg-slate-950 text-slate-100 min-h-screen flex items-center justify-center font-sans antialiased">
      <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10">
        <div className="absolute -top-40 -left-40 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 -right-40 w-96 h-96 bg-indigo-600/20 rounded-full blur-3xl"></div>
      </div> 

      <div className="d-flex flex-column min-vh-100 container-fluid" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Router>
          <AOSRouteHandler />
          <AppContent />
        </Router>
      </div>
    </div>
  );
}

export default App;